import BankLogoComponent from "@portal/components/atoms/bankLogo";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";

import { NORNE_CENTERID } from "@portal/assets/banks";
import { StartPageLanguage } from "../../startpage/components";
import RobotHeaderText from "../robotHeaderText";
import { ProgressBarComponent } from "@portal/components/atoms/v2/progressBar";
interface Props {
  pageIndex: number;
  isDefaultLanguage: boolean;
  centerId: string;
  isIFrame: boolean;
  hideContent?: boolean;
}

/**
 * The header component for the application shows the header for each page, and the progress bar.
 * @param interface
 * @returns a progress bar and a header text.
 */
export const HeaderComponent = ({ pageIndex, isDefaultLanguage, centerId, isIFrame, hideContent = false }: Props) => {
  const isFirstPage = pageIndex === 0;
  const backgroundColorClass = GetHeaderBackgroundColorClassForRobot(isFirstPage, isIFrame, centerId);
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const headers = [
    "",
    texts.PAGE_1_HEADER,
    texts.PAGE_2_HEADER,
    texts.PAGE_3_HEADER,
    texts.PAGE_4_HEADER,
    texts.PAGE_5_HEADER,
    texts.PAGE_6_HEADER,
    texts.PAGE_7_HEADER,
    texts.PAGE_7_HEADER,
    texts.PAGE_8_HEADER,
    texts.PAGE_9_HEADER,
    texts.PAGE_10_HEADER,
    texts.PAGE_11_HEADER,
    texts.PAGE_12_HEADER,
    texts.PAGE_13_HEADER,
    texts.PAGE_14_HEADER,
    texts.PAGE_15_HEADER,
    texts.PAGE_16_HEADER,
    texts.PAGE_17_HEADER,
  ];

  const renderFirstPageHeader = (isIFrame: boolean) => (
    <div
      className={`flex flex-col items-center gap-2 sm:gap-4 w-full sm:rounded-t-xl border-b border-boxBorderColor dark:border-greyDark dark:bg-gray-950 h-20 ${backgroundColorClass}`}
    >
      <div className="flex w-full justify-between">
        <div className="flex mt-2 ml-5">{isIFrame && <BankLogoComponent centerId={centerId} />}</div>
        <div className="flex mr-3.5 mt-3.5">
          <StartPageLanguage
            isPrimaryLanguage={isDefaultLanguage}
            primaryLanguageText={texts.TEXT_LANGUAGE_A}
            secondaryLanguageText={texts.TEXT_LANGUAGE_B}
            isIFrame={isIFrame}
            centerId={centerId}
          />
        </div>
      </div>
    </div>
  );

  if (isFirstPage) return renderFirstPageHeader(isIFrame);

  return (
    <div className="flex w-[calc(100%+2px)] sticky top-0 h-20 sm:h-24 border border-boxBorderColor  dark:border-greyDark rounded-t-xl">
      <div
        className={`flex flex-col items-center gap-2 sm:gap-4 w-full sm:rounded-t-xl h-20 sm:h-auto dark:bg-gray-800 dark:border-b dark:border-blueBorderDark ${backgroundColorClass}`}
      >
        {!hideContent && (
          <div className="flex flex-col w-full">
            <div className="flex justify-center mt-1">
              <ProgressBarComponent pageIndex={pageIndex} totalPages={18} />
            </div>
            <div className="flex mt-1 justify-center text-robotHeaderBackgroundText dark:text-white">
              <RobotHeaderText text={headers[pageIndex]} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const GetHeaderBackgroundColorClassForRobot = (isFirstPage: boolean, isIFrame: boolean, centerId: string) => {
  if (
    isFirstPage &&
    isIFrame &&
    !(
      centerId === NORNE_CENTERID ||
      centerId === "2220" ||
      centerId === "9820" ||
      centerId === "4589" ||
      centerId === "4730" ||
      centerId === "4605"
    )
  ) {
    return "bg-greyLight";
  }
  return "bg-primary";
};
